import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { apiUrl } from "../config/url";
import Navbar from "./Navbar";

const CoMaster = () => {
  const user_role = localStorage.getItem("user_role");

  const [coMasters, setCoMasters] = useState([]);
  const [filteredCoMasters, setFilteredCoMasters] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [newCoMaster, setNewCoMaster] = useState({
    code: "",
    name: "",
    address_1: "",
    address_2: "",
    contact: "",
  });
  const [editMode, setEditMode] = useState(false);
  const [currentCoMaster, setCurrentCoMaster] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true); // Initialize loading state

  useEffect(() => {
    fetchCoMasters();
  }, []);

  useEffect(() => {
    setFilteredCoMasters(
      coMasters.filter(coMaster =>
        (coMaster.name?.toLowerCase().includes(searchTerm.toLowerCase()) || '') ||
        (coMaster.contact?.includes(searchTerm) || '') ||
        (coMaster.code?.includes(searchTerm) || '')
      )
    );
  }, [searchTerm, coMasters]);


  const fetchCoMasters = async () => {
    setLoading(true); // Set loading to true when starting to fetch data
    try {
      const token = localStorage.getItem("api_token");
      const response = await axios.get(`${apiUrl}/admin/getAllCoMasters`, {
        headers: {
          api_token: token,
        },
      });

      if (Array.isArray(response.data.data)) {
        setCoMasters(response.data.data);
        setFilteredCoMasters(response.data.data); // Initialize filtered list
      } else {
        console.error("Expected an array but got:", response.data);
        toast.error("Failed to fetch records");
      }
    } catch (error) {
      console.error("Error fetching co masters", error);
      toast.error("Failed to fetch records");
    } finally {
      setLoading(false); // Set loading to false after the API call completes
    }
  };

  const createCoMaster = async () => {
    try {
      const token = localStorage.getItem("api_token");

      await axios.post(`${apiUrl}/admin/createCoMaster`, newCoMaster, {
        headers: {
          api_token: token,
        },
      });
      fetchCoMasters();
      resetForm();
      setIsModalOpen(false);
      toast.success("CoMaster created successfully");
    } catch (error) {
      console.error("Error creating co master", error);
      toast.error("Failed to create co master");
    }
  };

  const updateCoMaster = async () => {
    try {
      const token = localStorage.getItem("api_token");
      await axios.post(
        `${apiUrl}/admin/updateCoMaster`,
        { ...currentCoMaster, ...newCoMaster },
        {
          headers: {
            api_token: token,
          },
        }
      );
      toast.success("CoMaster updated successfully");
      fetchCoMasters();
      resetForm();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error updating co master", error);
      toast.error("Failed to update co master");
    }
  };

  const handleEdit = (coMaster) => {
    setCurrentCoMaster(coMaster);
    setNewCoMaster({
      co_id: coMaster.id,
      code: coMaster.code,
      name: coMaster.name,
      address_1: coMaster.address_1,
      address_2: coMaster.address_2,
      contact: coMaster.contact,
    });
    setEditMode(true);
    setIsModalOpen(true);
  };

  const openCreateModal = () => {
    resetForm();
    setEditMode(false);
    const nextCode = coMasters.length + 1; // Set default code as count + 1
    setNewCoMaster((prev) => ({ ...prev, code: nextCode.toString() })); // Convert to string if needed
    setIsModalOpen(true);
  };

  const resetForm = () => {
    setNewCoMaster({
      code: "",
      name: "",
      address_1: "",
      address_2: "",
      contact: "",
    });
    setCurrentCoMaster(null);
    setEditMode(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      updateCoMaster();
    } else {
      createCoMaster();
    }
  };

  return (
    <>
      <Navbar />
      <div>
        <ToastContainer />
        <h1 className="my-6 text-3xl font-bold text-center">C/O Master Management</h1>


        {loading ? ( // Show loading indicator while fetching data
          <div className="py-4 text-center">
            <p>Loading...</p>
          </div>
        ) : (
        
              <div className="flex justify-center">
                <table className="bg-white border border-gray-200 table-auto inline-table">
                  <thead>
                    <tr className="border-none">
                      <th colSpan={user_role === "1" ? 7 : 6} className="p-4 border-none bg-white">
                        <div className="flex justify-between items-center">
                          <input
                            type="text"
                            placeholder="Search by Name, Contact or Code"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="p-2 border border-gray-300 rounded w-1/2"
                          />
                          {user_role === "1" && (
                            <button
                              onClick={openCreateModal}
                              className="px-4 py-2 text-white bg-blue-600 rounded"
                            >
                              Create CoMaster
                            </button>
                          )}
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <th className="px-4 py-2 border bg-gray-100 text-gray-800 font-semibold text-left">ID</th>
                      <th className="px-4 py-2 border bg-gray-100 text-gray-800 font-semibold text-left">Code</th>
                      <th className="px-4 py-2 border bg-gray-100 text-gray-800 font-semibold text-left">Name</th>
                      <th className="px-4 py-2 border bg-gray-100 text-gray-800 font-semibold text-left">Address 1</th>
                      <th className="px-4 py-2 border bg-gray-100 text-gray-800 font-semibold text-left">Address 2</th>
                      <th className="px-4 py-2 border bg-gray-100 text-gray-800 font-semibold text-left">Contact</th>
                      {user_role === "1" && <th className="px-4 py-2 border bg-gray-100 text-gray-800 font-semibold text-left">Actions</th>}
                    </tr>
                  </thead>
                  <tbody className="text-base">
                    {filteredCoMasters.map((coMaster) => (
                      <tr key={coMaster.co_id} className="even:bg-gray-50">
                        <td className="px-4 py-2 border text-gray-800">{coMaster.id}</td>
                        <td className="px-4 py-2 border text-gray-800">{coMaster.code}</td>
                        <td className="px-4 py-2 border text-gray-800">{coMaster.name}</td>
                        <td className="px-4 py-2 border text-gray-800">{coMaster.address_1}</td>
                        <td className="px-4 py-2 border text-gray-800">{coMaster.address_2}</td>
                        <td className="px-4 py-2 border text-gray-800">{coMaster.contact}</td>
                        {user_role === "1" && (
                          <td className="px-4 py-2 border text-center">
                            <button
                              onClick={() => handleEdit(coMaster)}
                              className="px-3 py-1 text-sm text-white bg-yellow-500 rounded hover:bg-yellow-600"
                            >
                              Edit
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

           

        )}

        {isModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="p-6 bg-white rounded shadow-lg w-96">
              <h2 className="mb-4 text-lg font-bold">{editMode ? "Edit CoMaster" : "Create CoMaster"}</h2>
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  placeholder="Code"
                  value={newCoMaster.code}
                  onChange={(e) => setNewCoMaster({ ...newCoMaster, code: e.target.value })}
                  required
                  className="w-full p-2 mb-2 border border-gray-300 rounded"
                />
                <input
                  type="text"
                  placeholder="Name"
                  value={newCoMaster.name}
                  onChange={(e) => setNewCoMaster({ ...newCoMaster, name: e.target.value })}
                  required
                  className="w-full p-2 mb-2 border border-gray-300 rounded"
                />
                <input
                  type="text"
                  placeholder="Address 1"
                  value={newCoMaster.address_1}
                  onChange={(e) => setNewCoMaster({ ...newCoMaster, address_1: e.target.value })}
                  className="w-full p-2 mb-2 border border-gray-300 rounded"
                />
                <input
                  type="text"
                  placeholder="Address 2"
                  value={newCoMaster.address_2}
                  onChange={(e) => setNewCoMaster({ ...newCoMaster, address_2: e.target.value })}
                  className="w-full p-2 mb-2 border border-gray-300 rounded"
                />
                <input
                  type="text"
                  placeholder="Contact"
                  value={newCoMaster.contact}
                  onChange={(e) => setNewCoMaster({ ...newCoMaster, contact: e.target.value })}
                  required
                  className="w-full p-2 mb-4 border border-gray-300 rounded"
                />
                <button
                  type="submit"
                  className="w-full px-4 py-2 text-white bg-green-600 rounded"
                >
                  {editMode ? "Update CoMaster" : "Create CoMaster"}
                </button>
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="w-full px-4 py-2 mt-2 text-white bg-red-600 rounded"
                >
                  Cancel
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CoMaster;
